import React, { useState } from 'react';
import styles from './styles.module.scss';

const Tooltip = ({ children, content, position = 'top', theme = 'blackAndWhite', className = '', ...props }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => setIsVisible(true);
  const handleMouseLeave = () => setIsVisible(false);
  // const handleFocus = () => setIsVisible(true);
  const handleFocus = () => {};
  const handleBlur = () => setIsVisible(false);

  return (
    <div
      className={`${styles.tooltipContainer} ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
      tabIndex="0"
      role="tooltip"
      aria-describedby="tooltip-content"
      {...props}
    >
      {children}
      <div
        id="tooltip-content"
        className={`${styles.tooltip} ${styles[position]} ${styles[theme]} ${isVisible ? styles.visible : ''}`}
        aria-hidden={!isVisible}
      >
        {content}
      </div>
    </div>
  );
};

export default Tooltip;